<template>
  <div class="main-contents">
    <header>
      <div class="header-top-inner">
        <a href="/">
        <div class="item">
          <h1>ハワイPCR検査センター</h1>
        </div>
      </a>
        <div class="item cv">
          <ul>
            <a href="https://lin.ee/BXdbFKG"><li>お問い合わせはこちら</li></a>
            <a href="/contact"><li class="contact-btn">お申し込み</li></a>
          </ul>
        </div>
      </div>
    </header>
    <div id="content01" class="content show">
      <div class="main-visual">
        <a href="/contact">
          <img src="../assets/mv-sp.png" class="pcnone">
          <img src="../assets/mv-pc.png" class="spnone">
        </a>
      </div>
      <div class="success">
        <h1>ワイキキ支店の料金での決済が完了しました。ご入力いただきましたメールアドレス宛にご請求書をメールで送信しております。当日は現地検査センター受付でお見せください。</h1>
      </div>
      <div class="flow">
        <h2>来店検査の証明書取得の流れ</h2>
        <div class="flow-inner">
          <div class="step-wrap4">
            <div class="step-content4">
              <div class="step-label4">STEP</div>
              <div class="step-title4">検査のお申し込み</div>
              <div class="step-body4" style="border-bottom: dotted 2px #ddd;">
                <p>日本へご帰国する搭乗便の72時間以内の検査が必要です。WEBから簡単に検査予約が出来ます。 ご入力いただいた帰国日からAIコンシェルジュがお客様に最適な日時・場所・プランをご提示いたします。<br><br>AIコンシェルジュがお客様の帰国時間に基づき、最適なお客様の日本帰国時PCR検査の受検期間※1を<span class="strength">分かりやすく</span>ご提示いたします。<br>※1当日を除く、帰国前72時間以内の範囲で受検可能期間を青色で表示いたします。</p>
              </div>

            </div>
            <div class="step-content4">
              <div class="step-label4">STEP</div>
              <div class="step-title4">お支払い</div>
              <div class="step-body4" style="border-bottom: dotted 2px #ddd;">
                <p>日時・場所・プランが決定しましたら、決済リンクをお申し込み時のメールアドレスに送信いたします。クレジットカード情報をご入力いただき、お支払いをお願いいたします。<label>※ お支払いは検査日の1週間前までにお願いいたします。</label></p>
                <p>お支払い方法：オンライン予約後クレジットカード払い</p>
                <img src="https://theme.zdassets.com/theme_assets/1311631/1fc3520f5f36e6cf5aea084413e53ff0eb9e2bbb.png">
              </div>
            </div>
            <div class="step-content4">
              <div class="step-label4">STEP</div>
              <div class="step-title4">ご予約日時に検査センターへご来店</div>
              <div class="step-body4" style="border-bottom: dotted 2px #ddd;">
                <p><a href="#place">検査センターはこちら</a></p>
                <p>注意事項：</p>
                <ul>
                  <li>検査を受ける方、全員のパスポートをご持参の上、お客様ご自身で検査センターまでお越しください。</li>
                  <li>17歳以下の未成年者は保護者の同伴が必要です。また5歳以下のお子さまの検査は保護者の介助が必要です。</li>
                  <li>検査当日に体調不良、38度以上の高熱のあるお客様は検査をお受けいただく事ができません。ご来店になる前に検査センターまでお電話ください。</li>
                  <li>検査日に鼻薬等を塗ると判定ができなくなりますので、ご使用されないようお願いいたします。</li>
                </ul>
              </div>
            </div>
            <div class="step-content4">
              <div class="step-label4">STEP</div>
              <div class="step-title4">最短15分でPCR検査が終了します</div>
            </div>
            <div class="step-content4">
              <div class="step-label4">STEP</div>
              <div class="step-title4">陰性証明書を添付してメール送信いたします</div>
              <div class="step-body4" style="border-bottom: dotted 2px #ddd;">※陰性証明書の印刷をご希望の方は、検査結果通知メールをご確認いただいた後、再来店いただきました際にお渡しいたします。お渡しする際は、ご本人様を確認いたしますのでパスポート等身分証明書をご提示いただくようお願いいたします。</div>
            </div>
          </div>
        </div>
      </div>
      <div class="place" id="place">
        <h2>検査センターについて</h2>
        <div class="place-info">
          <div class="first">
            <div class="place-inner">
              <div class="pla">
                <img src="../assets/center02.png">
              </div>
              <div class="pla two">
                <p class="title">ハワイPCR検査センターワイキキ支店(相馬クリニック)</p>
                <p class="description">Bank of HawaiiやLongs Drugsがあるカラカウア通りの派手なビルの1Fです。午後が比較的空いていおり、スムーズに検査が可能です。</p>
                <p class="info">
                  検査時間：8:30～18:00（最終受付17時45分）<br>土日も検査可能
                </p>
                <a href="">受付窓口までの順路をご案内</a>
              </div>
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <th>連絡先</th>
                  <td><a href="tel:18083582182">1-(808)  358-2182</a></td>
                </tr>
                <tr>
                  <th>メールでの問い合わせ</th>
                  <td>contact@pcrhawaii.com</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!---
          <div class="first">
            <div class="place-inner">
              <div class="pla">
                <img src="../assets/center02.png">
              </div>
              <div class="pla two">
                <p class="title">ハワイPCR検査センターアラモアナ支店 (相馬クリニック)</p>
                <p class="description">アラモアナセンターに隣接してる最上階に円盤のレストランが目印です。</p>
                <p class="info">
                  検査時間：8:30～18:00（最終受付17時45分）<br>土日も検査可能
                </p>
                <a href="">受付窓口までの順路をご案内</a>
              </div>
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <th>連絡先</th>
                  <td><a href="tel:18083582182">1-(808)  358-2182</a></td>
                </tr>
                <tr>
                  <th>メールでの問い合わせ</th>
                  <td>contact@pcrhawaii.com</td>
                </tr>
              </tbody>
            </table>
          </div>-->
        </div>
      </div>
    </div>
    <div id="content02" class="content">
    </div>
    <div class="bnr">
        <div class="bnr-inner">
          <div class="b">
            <a href="tel:03-4400-1511"><img src="../assets/tel-bnr.jpeg"></a>
          </div>
           <div class="b">
            <a href="https://lin.ee/BXdbFKG"><img src="../assets/line-bnr.jpeg"></a>
           </div>
        </div>
      </div>
    <footer style="text-align: center;">
      Copyright © 2022 Kirarin.Co.,Ltd.
    </footer>
    <div style="text-align: center;">
      <div class="pcnone banner">
        <div class="" style="text-align: center;">
           <a href="/contact"><div class="contact-btn">お申し込み</div></a>
        </div>
      </div>
    </div>
  </div>
</template>
 <!-- Global site tag (gtag.js) - Google Ads: 10946673266 -->
    <script async src="https://www.googletagmanager.com/gtag/js?id=AW-10946673266"></script>
    <script>
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());

      gtag('config', 'AW-10946673266');
    </script>
<script>
export default {
  name: 'Top',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted: function () {
    document.getElementById('content01').classList.add('show')
  },
  methods: {
    btn01: function () {
      document.getElementById('btn02').classList.remove('selected')
      document.getElementById('btn01').classList.add('selected')
      document.getElementById('content01').classList.add('show')
      document.getElementById('content02').classList.remove('show')
    },
    btn02: function () {
      document.getElementById('btn01').classList.remove('selected')
      document.getElementById('btn02').classList.add('selected')
      document.getElementById('content01').classList.remove('show')
      document.getElementById('content02').classList.add('show')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1{
  font-family: M PLUS Rounded\ 1c,sans-serif;
  font-weight: bolder!important;
}
.banner{
  display: none;
}
a{text-decoration: none;}
h1, h2 {
  font-weight: normal;
  margin: 0px!important;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: white;
}
.step-content4 a{
  color: #196FB9;
}
#place a{
   color: #196FB9;
}
h1 img{
  width: 100%!important;
}
body{
  margin: 0 auto!important;
}
h1{
padding: 16px;
}
.success h1{
  font-size: 1.5em;
    width: 60%;
    margin: 5% auto!important;
    display: block;
    text-align: left;
    line-height: 2em;
}
header{
  background: #196FB9;
}
.spnone{
  display: block;
}
.pcnone{
  display: none;
}
.main-visual img{width: 100%;}
.header-top-inner{
  display: flex;
  justify-content: space-between;
  padding: 16px;
  padding-top: 0px;
  padding-bottom: 0px;
  color: white;
}
.header-top-inner .item{
  color: white;
}
.header-bottom-inner {
  display: flex;
  margin: 0 auto;
  width: 60%;
}
.header-bottom-inner .item{
  width: 50%;
}
/*
#app {
  margin-top: 0px!important;
  background: url(../assets/bkimage.png);

}
#form-main{
  background: url(../assets/bkimage.png);
  padding-bottom: 5%;
}*/
.feature{
}
.feature h2{

    font-size: 2em;
    line-height: 0.6em;
    font-weight: 800;
    font-style: normal;
    letter-spacing: .1em;
    text-align: center;
    width: 100%;
    color: coral;
    white-space: nowrap;
    padding-bottom: 8px;
    margin-bottom: 16px;
}
.contact h2{

    font-size: 2em;
    line-height: 0.6em;
    font-weight: 800;
    font-style: normal;
    letter-spacing: .1em;
    text-align: center;
    width: 100%;
    color: coral;
    white-space: nowrap;
    padding-bottom: 8px;
    margin-bottom: 16px;

}

/* CTA_05 */

.cta05-cvset {
    padding: 100px 0 0;
    width: 90%;
    margin: 0 auto;
}

.cta05-cvset .cta05-inner {
    background-color: #f4fcf4;
    padding: 10px 0 20px;
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
}

.cta05-cvset .cta05-inner ul {
    list-style:none;
    margin-top: 40px;
    padding-inline-start:0;
    border: none;
    padding: 0;
}

.cta05-cvset-title {
    position: relative;
    font-size: 1.8em;
    line-height: 0.6em;
    font-weight: 800;
    font-style: normal;
    letter-spacing: .1em;
    position: absolute;
    top: -10px;
    left: 0;
    text-align: center;
    width: 100%;
}
.cta05-cvset-title .deco {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 20px;
    color: coral;
    white-space: nowrap;
    padding-bottom: 8px;
    margin-bottom: 16px;
}

.cta05-cvset-title .deco:before, .cta05-cvset-title .deco:after {
    display: inline-block;
    position: absolute;
    top: 42%;
    width: 28px;
    height: 2px;
    border-radius: 3px;
    background-color: coral;
    content: "";
    margin: auto -35px;
}
.cta05-cvset-title .deco:before {
    left: 0;
    -webkit-transform: rotate(50deg);
    transform: rotate(50deg);
}

.cta05-cvset-title .deco:after {
    right: 0;
    -webkit-transform: rotate(-50deg);
    transform: rotate(-50deg);
}

.cta05-cvset-list {
    display: flex;
    width: 100%;
    max-width: 780px;
    justify-content: space-between;
    margin: 0 auto;
}
.cta05-cvset-list li {
    max-width: 360px;
    width: 100%;
    margin: 0 5px;
}
.cta05-cvset-list img {
    width:100%;
    text-align:center;
}
.cta05-button.dwl, .cta05-button.etm {
    background-color: #fff;
    border: 3px solid #005fa0;
    color: #005fa0;
}
.cta05-button.dwl, .cta05-button.dmo, .cta05-button.etm {
    height: 56px;
    font-size: 24px;
    font-weight: bold;
    line-height: 1.4em;
    text-align: center;
    flex-direction: column;
    white-space: nowrap;
    text-decoration: none;
}
.cta05-button.dmo {
    background: linear-gradient(#217669, #224364);
    border: 0px solid #005fa0;
    color: #fff;
    width: 80%;
    margin: 5% auto;
}
.cta05-button {
    position: relative;
    display: flex;
    width: 100%;
    height: 72px;
    text-align: center;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    border-radius: 12px;
    margin: 0;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 6px 10px -2px rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.2);
    transition: 0.2s ease-in-out;
}
.cta05-button.free::after {
    content: "無料";
    position: absolute;
    display: block;
    top: -17px;
    right: 8px;
    width: 80px;
    height: 30px;
    font-size: 16px;
    font-weight: bold;
    line-height: 32px;
    text-align: center;
    background-color: coral;
    color: #fff;
    border-radius: 16px;
}
.cta05-button.dwl:hover, .cta05-button.dmo:hover, .cta05-button.etm:hover {
    background-color: #6bb6ff;
    box-shadow: 0 15px 30px -5px rgba(0, 0, 0, 0.15), 0 0 5px rgba(0, 0, 0, 0.1);
    transform: translateY(-4px);
}
.cta05-button.dwl small, .cta05-button.dmo small, .cta05-button.etm small {
    display: block;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.2em;
    letter-spacing: 0;
    margin-bottom: 4px;
    white-space: nowrap;
}
.cta05-cvset-list span{
  font-weight: 700;
}
@media screen and (max-width: 768px){
.cta05-cvset .cta05-inner {
    padding: 40px 20px 32px;
}
.cta05-cvset-list {
    flex-direction: column;
    align-items: center;
    padding-bottom: 16px;
}
.cta05-button.dwl small, .cta05-button.dmo small, .cta05-button.etm small {
    font-size: 12px;
}
}
/* container */
.wrapper{
    width:100%;
    background-color:transparent;
}
.wrapper .container{
    max-width:1000px;
    margin:0px auto;
    padding:80px 0px;
}
/* content */
@media (min-width: 992px) {
    .wrapper .container .content {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 90%;
    margin: 0 auto;
    }
}
.wrapper .content-item {
    width:100%;
}
@media (min-width: 992px) {
    .wrapper .content-item {
        width:50%;
    }
}
.wrapper .image{
    display:block;
    max-width:100%;
    margin:0px auto;
}
.wrapper .text{
    padding:50px;
}
.wrapper .text .heading{
    margin:0px 0px 40px 0px;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
}
/* container */
.wrapper2{
    width:100%;
    background-color:transparent;
}
.wrapper2 .container{
    max-width:1000px;
    margin:0px auto;
    padding:80px 0px;
}
/* content */
@media (min-width: 992px) {
    .wrapper2 .container .content {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 90%;
    margin: 0 auto;
    }
}
/* PC時のみ順番を入れ替える */
@media (min-width: 992px) {
    .wrapper2 .content {
        flex-direction:row-reverse;
    }
}
.wrapper 2.content-item {
    width:100%;
}
@media (min-width: 992px) {
    .wrapper2 .content-item {
        width:50%;
    }
}
.wrapper2 .image{
    display:block;
    max-width:100%;
    margin:0px auto;
}
.wrapper2 .text{
    padding:50px;
}
.wrapper2 .text .heading{
    margin:0px 0px 40px 0px;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
}
.text p{
  line-height: 2em;
}

@import url(https://fonts.googleapis.com/css?family=Montserrat:400,700);

#feedback-page{
  text-align:center;
}

#form-main{
  width:100%;
  float:left;
  padding-top:0px;
}

#form-div {
  background-color: rgba(72,72,72,0.4);
    padding-left: 35px;
    padding-right: 35px;
    padding-top: 35px;
    padding-bottom: 50px;
    width: 80%;
    /* float: left; */
    display: block;
    /* left: 50%; */
    margin: 0 auto;
    /* position: absolute; */
    margin-top: 30px;
    /* margin-left: -260px; */
    -moz-border-radius: 7px;
    -webkit-border-radius: 7px;
}

.feedback-input {
  color:#3c3c3c;
  font-family: Helvetica, Arial, sans-serif;
  font-weight:500;
  font-size: 18px;
  border-radius: 0;
  line-height: 22px;
  background-color: #fbfbfb;
  padding: 13px 13px 13px 13px;
  margin-bottom: 10px;
  width:100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
  border: 3px solid rgba(0,0,0,0);
}

.feedback-input:focus{
  background: #fff;
  box-shadow: 0;
  border: 3px solid #3498db;
  color: #3498db;
  outline: none;
  padding: 13px 13px 13px 13px;
}

.focused{
  color:#30aed6;
  border:#30aed6 solid 3px;
}

/* Icons ---------------------------------- */
#name{
  background-image: url(http://rexkirby.com/kirbyandson/images/name.svg);
  background-size: 30px 30px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}

#name:focus{
  background-image: url(http://rexkirby.com/kirbyandson/images/name.svg);
  background-size: 30px 30px;
  background-position: 8px 5px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}

#email{
  background-image: url(http://rexkirby.com/kirbyandson/images/email.svg);
  background-size: 30px 30px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}

#email:focus{
  background-image: url(http://rexkirby.com/kirbyandson/images/email.svg);
  background-size: 30px 30px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}

#comment{
  background-image: url(http://rexkirby.com/kirbyandson/images/comment.svg);
  background-size: 30px 30px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}

#date{
  background-image: url(http://rexkirby.com/kirbyandson/images/email.svg);
  background-size: 30px 30px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}
#date:focus{
  background-image: url(http://rexkirby.com/kirbyandson/images/email.svg);
  background-size: 30px 30px;
  background-position: 11px 8px;
  background-repeat: no-repeat;
}

textarea {
    width: 100%;
    height: 150px;
    line-height: 150%;
    resize:vertical;
}

input:hover, textarea:hover,
input:focus, textarea:focus {
  background-color:white;
}

#button-blue{
  font-family: 'Montserrat', Arial, Helvetica, sans-serif;
  float:left;
  width: 100%;
  border: #fbfbfb solid 4px;
  cursor:pointer;
  background: linear-gradient(#217669, #224364);
  color:white;
  font-size:24px;
  padding-top:22px;
  padding-bottom:22px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
  margin-top:-4px;
  font-weight:700;
}

#button-blue:hover{
  opacity: 0.7;
}
.submit:hover {
  opacity: 0.7;
}
.ease {
  width: 0px;
  height: 74px;
  background-color: #fbfbfb;
  -webkit-transition: .3s ease;
  -moz-transition: .3s ease;
  -o-transition: .3s ease;
  -ms-transition: .3s ease;
  transition: .3s ease;
}

.submit:hover .ease{
  width:100%;
  background-color:white;
}

@media only screen and (max-width: 580px) {
  #form-div{
    left: 3%;
    margin-right: 3%;
    width: 88%;
    margin-left: 0;
    padding-left: 3%;
    padding-right: 3%;
  }
}
.contact{
  background-color:transparent;
}
.form-inner{
  background-color:transparent;
}

@media only screen and (max-width: 1080px) {
body {
    width: 100%!important;
}
.spnone{
  display: none;
}
.pcnone{
  display: block;
}
.wrapper .container {
    padding: 0px;
}
.wrapper {
    margin-top: 10%;
    }
.wrapper2 .container {
    padding: 0px;
}
#form-div {
    left: 0%;
    margin-right: initial;
    width: 88%;
    display: block;
    margin: 10% auto;
}
.cta05-cvset .cta05-inner {
    padding: 16px;
}
.cta05-cvset .cta05-inner {
  width: initial;
  }
  .cta05-cvset-title {
    font-size: 1.2em;
    top: -5px;
  }
}
/**/
.header-bottom-inner{display: flex; width: 80%; justify-content: space-between;color: white; font-weight: bold;}
.header-bottom-inner .btn-inner{display: contents;}
.header-bottom-inner .item{width: 80%;margin: 16px auto;font-size: 1.2em;border-radius: 20px;}
.selected {background: #5b97cd;}
.content{display: none;}
.show{display: block;}
.feature{padding: 5%;}
.feature-inner{display: flex;justify-content: space-between;}
.fea{width: 23%;}
.fa, .fas {font-size: 3em;color: #196FB9;}
h2{
  position: relative;
    font-family: "M PLUS Rounded 1c", sans-serif;
    font-weight: bold;
    color: #196FB9;
    text-align: center;
    font-size: 2rem;
    margin: 93px 0 40px;
    padding: 0 20px 30px;
}
h2:after {
    position: absolute;
    bottom: 0;
    left: 50%;
    display: block;
    content: "";
    width: 80px;
    height: 5px;
    background-color: #196FB9;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    -webkit-transform: translate(-50%, 0);
    -moz-transform: translate(-50%, 0);
    -ms-transform: translate(-50%, 0);
    -o-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
}
.service table{
  margin: 2% auto;
  width: 60%;
}
.table th {
    border-top: 1px solid #fff;
    background-color: #196FB9;
    text-align: center;
    color: #fff;
    padding: 15px;
}
.table td {
    border-top: 1px solid #fff;
    border-left: 1px solid #fff;
    background-color: #F1F7FC;
    color: #196FB9;
    padding: 15px 40px;
    text-align: left;
}
.table .key{
  width: 30%;
}
.service .description{text-align: left;width: 60%; margin:16px auto;}
.flow-inner{ width: 50%;margin: 0 auto;}
.place-inner{ display: flex;justify-content: space-between;width: 60%;margin: 0 auto;  }
.place-info{margin: 5% auto;}
.pla{width: 50%;}
.pla img{width: 100%;}
.place-info table{
  margin: 0 auto;
  width: 60%;
}
.place-info .first{margin-bottom: 5%;}
.service{margin-bottom: 5%;}
.flow{margin-bottom: 5%;}
.place{margin-bottom: 5%;}
.feature{margin-bottom: 5%;}
.contact-btn{
  background: orange;
    border-radius: 20px;
    padding: 8px;
    padding-left: 36px;
    padding-right: 36px;
    letter-spacing: .2em;
}
.two{
  padding: 24px;
    text-align: left;
}
.two .title{
  font-size: 1.5em;
    font-weight: bold;
    color: #196FB9;
}
@media only screen and (max-width: 1080px) {
  .step-body4 img{
    width: 100%;
  }
  .flow-inner {
    width: 90%;
  }
  .service .description {
    width: 90%;
  }
  .service table {
    width: 90%;
  }
  .place-inner {
     width: 90%;
   }
   .feature-inner{
    display: block;
   }
   .fea {
    width: 80%;
    margin: 10% auto;
}
.cv{display: none;}
table th,
table td{

  width:100%;

  display:block;
  width: 90%;

}
.table td {
    padding: 0px;
    width: 100%;

}
.table .key {
    width: 92%;
}
.place-inner {
    width: 90%;
    display: block;
}
.pla {
    width: 100%;
}
.place-info table {
    margin: 0 auto;
    width: 90%;
}
.first .table td {
    padding: 0px;
    width: 98%;
}
.two {
    padding: 0px;
    margin: 5% auto;
    text-align: left;

}
.place-info .first {
    margin-bottom: 15%;
}
.place {
    margin-bottom: 15%;
}
.service {
    margin-bottom: 15%;
}
.flow {
    margin-bottom: 15%;
}
.banner .contact-btn{
  display: block;
    width: 300px;
}
}

/***ステップバーデザイン4***/
.step-wrap4 {
 counter-reset: count;
 margin: 2em 0;
 position: relative;
}
.step-content4 {
 padding: 1em 0 1.3em 2.5em;
 margin: 0;
 text-align: left;
 position: relative;
}
.step-content4::before {
 content: "";
 display: block;
 width: 55px;
 height: 55px;
 background: #759bcc;
 border-radius: 50%;
 position: absolute;
 top: 0;
 left: -3px;
}
.step-content4::after {
 content: "";
 display: block;
 height: calc(100% - 55px);
 border-left: solid 2px #ddd;
 position: absolute;
 top: 55px;
 left: 10px;
}
.step-label4 {
 color: #fff;
 font-weight: bold;
 font-size: 12px;
 position: absolute;
 top: 6px;
 left: 9px;
}
.step-label4::after {
 counter-increment: count;
 content: counter(count);
 position: absolute;
 font-size: 30px;
 top: 8px;
 left: 7px;
}
.step-title4 {
 font-weight: bold;
 font-size: 120%;
 margin-left: 1.5em;
}
.step-body4 {
 margin-top: 1em;
 padding: 0 0 1em;
 border-bottom: dotted 2px #ddd;
}
.step-wrap4 > :last-of-type::after {
 display: none;
}
/***ステップバーデザイン４***/
.banner{
  background: transparent;
    padding: 0px;
    position: fixed;
    bottom: 0px;
    width: 100%;
    padding: 0px;
}
.eme-btn{
  background: #196FB9;
    border-radius: 20px;
    padding: 8px;
}
.banner li{
  padding-left: 0px;
}
.banner .contact-btn {
    margin: 8px auto;
    padding: 8px;
}

/*faq*/
.cp_qa *, .cp_qa *:after, .cp_qa *:before {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
.cp_qa {
  overflow-x: hidden;
  margin: 0 auto;
  color: #196FB9;
}
.cp_qa .cp_actab {
  padding: 20px 0;
  border-bottom: 1px dotted #cccccc;
}
.cp_qa label {
  font-size: 1.2em;
  position: relative;
  display: block;
  width: 100%;
  margin: 0;
  padding: 10px 10px 0 48px;
  cursor: pointer;
}
.cp_qa .cp_actab-content {
  font-size: 1em;
  position: relative;
  overflow: hidden;
  height: 0;
  margin: 0 40px;
  padding: 0 14px;
  -webkit-transition: 0.4s ease;
          transition: 0.4s ease;
  opacity: 0;
}
.cp_qa .cp_actab input[type=checkbox]:checked ~ .cp_actab-content {
  height: auto;
  padding: 14px;
  opacity: 1;
}
.cp_qa .cp_plus {
  font-size: 2.4em;
  line-height: 100%;
  position: absolute;
  z-index: 5;
  margin: 3px 0 0 10px;
  -webkit-transition: 0.2s ease;
          transition: 0.2s ease;
}
.cp_qa .cp_actab input[type=checkbox]:checked ~ .cp_plus {
  -webkit-transform: rotate(45deg);
          transform: rotate(45deg);
}
.cp_qa .cp_actab input[type=checkbox] {
  display: none;
}
.faq-inner{
  width: 60%;
    margin: 5% auto;
}
.bnr{width: 60%; margin: 5% auto;}
.bnr-inner{display: flex; justify-content: space-between;}
.b img{width: 100%}
.b img:hover{opacity: 0.7;}
.b{width: 48%;}

@media only screen and (max-width: 1080px) {
  .faq-inner{
  width: 90%;
}
.header-top-inner{
  display: none;
}
.success h1{
  font-size: 1.3em;
  width: 90%;
}
.bnr-inner{
  display: block;

    width: 100%;
  }
  .b {
    width: 95%;
    margin: 5% auto;
}
.bnr {
    width: initial;
    margin: 10% auto;
}
}
</style>



// WEBPACK FOOTER //
// src/components/BuySuccess5.vue